/**
 * Shared application types – single source of truth for domain and route types.
 */

export type UserRole = 'admin' | 'editor' | 'writer'

export type UserStatus = 'active' | 'inactive'

export interface AppUser {
  id: string
  email: string
  displayName: string | null
  photoURL: string | null
  role: UserRole
}

export interface RelatedLink {
  title: string
  url: string
}

export interface GeneratedContent {
  site: string
  method: string
  source?: string | string[]
  generatedAt?: string
  title?: string
  intro?: string
  body?: string
  conclusion?: string
  relatedLinks?: RelatedLink[]
}

export interface RouteMetaRoles {
  roles: UserRole[]
}

export interface RouteMetaAuth {
  requiresAuth?: boolean
  guest?: boolean
}

export type RouteMeta = RouteMetaRoles & RouteMetaAuth

export const ROLES: UserRole[] = ['admin', 'editor', 'writer']

export function isUserRole(value: unknown): value is UserRole {
  return typeof value === 'string' && ROLES.includes(value as UserRole)
}
